import angular from 'angular';

function Directive() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    template: '<span ng-transclude></span>',
    link(scope, element, attrs) {
      const fileInput = angular.element('<input type="file" style="display:none" />');
      const fileSelectedFn = scope.$eval(attrs.fileSelected);

      element.after(fileInput);

      scope.selectImage = function() {
        fileInput.click();
      };

      fileInput.on('change', function() {
        if (this.files) fileSelectedFn(this.files);
      });
    }
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/imgUpload/index.js